import { isBlank } from 'helpers/string_helpers';
import { createSelector } from 'reselect';

export const noFiltersApplied = (state) => {
  const query = state.query;

  const tags = query.tags || [];
  const availabilities = query.availabilities || [];
  const assetClasses = query.assetClasses || [];
  const buildingClasses = query.buildingClasses || [];
  const investmentTypes = query.investmentTypes || [];

  const addressFilter = Object.keys(query.addressFilter).every((key) => {
    if (key === 'cities') return query.addressFilter[key].length === 0;
    return isBlank(query.addressFilter[key]);
  });

  const propertyFilter = Object.keys(query.propertyFilter).every((key) => {
    if (key === 'lotUnits') return true;
    return isBlank(query.propertyFilter[key]);
  });

  const saleFilter = Object.keys(query.saleFilter).every((key) => {
    if (key === 'leaseRateUnits') return true;
    return isBlank(query.saleFilter[key]);
  });

  const industrialFilter = Object.keys(query.industrialFilter).every((key) => {
    if (['driveThroughAccess', 'ready', 'served'].includes(key)) {
      return query.industrialFilter[key] === false;
    }
    return isBlank(query.industrialFilter[key]);
  });

  const filtersAreEmpty = addressFilter && saleFilter && propertyFilter && industrialFilter;
  const nothingIsSelected = buildingClasses.length === 0 &&
                            availabilities.length === 0 &&
                            assetClasses.length === 0 &&
                            investmentTypes.length === 0 &&
                            tags.length === 0;

  return filtersAreEmpty && nothingIsSelected && isBlank(query.searchText);
};

export const filtersApplied = createSelector(
  [noFiltersApplied],
  noFiltersApplied => !noFiltersApplied
);